import PropTypes from 'prop-types';

const formstackConfig = {
  url: 'https://trimet.formstack.com/forms/index.php',
  targetFrame: 'formSubmitTarget',
  formConfig: {
    form: { name: 'form', value: 5110063 },
    viewKey: { name: 'viewkey', value: 'yYQcPJ2yGX' },
    submit: { name: '_submit', value: 1 },
    tripUrl: { name: 'field136840501' },
    customerName: { name: 'field136840498' },
    description: { name: 'field136840499', required: true },
    email: { name: 'field136840500' },
    upload: {
      name: 'field136840518',
      accept: [
        'jpg',
        'jpeg',
        'gif',
        'png',
        'bmp',
        'tif',
        'psd',
        'pdf',
        'doc',
        'docx',
        'csv',
        'xls',
        'xlsx',
        'txt',
        'mp3',
        'mp4',
        'aac',
        'wav',
        'au',
        'wmv',
        'avi',
        'mpg',
        'mpeg',
        'zip',
        'gz',
        'rar',
        'z',
        'tgz',
        'tar',
        'sitx',
      ]
        .map(ext => `.${ext}`)
        .join(','),
    },
    userAgentData: { name: 'field136925721' },
  },
};

export const fieldType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  required: PropTypes.bool,
  accept: PropTypes.string,
});

export const formStackConfigType = PropTypes.shape({
  url: PropTypes.string.isRequired,
  targetFrame: PropTypes.string.isRequired,
  formConfig: PropTypes.shape({
    form: fieldType.isRequired,
    viewKey: fieldType.isRequired,
    submit: fieldType.isRequired,
    tripUrl: fieldType.isRequired,
    customerName: fieldType.isRequired,
    description: fieldType.isRequired,
    email: fieldType.isRequired,
    upload: fieldType.isRequired,
    userAgentData: fieldType.isRequired,
  }).isRequired,
});

export default formstackConfig;
